import { handleActions, Action } from 'redux-actions'

import { initialState, PopState as State } from './model'
import { prepareActions } from '../../../utils'
import { ErrSuccess, PopUploadParams } from '../../../types/form'

const actionsNames = [
  'fetchUploadPopStart',
  'postStatusPoll',
  'processingPool',
  'processingSetup',
  'setMaxDocuments',
  'uploadPop',
]

interface Actions {
  fetchUploadPopStart: () => Action<void>
  postStatusPoll: (payload: ErrSuccess) => Action<void>
  processingPool: (success: Function) => Action<void>
  processingSetup: (success: Function) => Action<void>
  setMaxDocuments: (payload: number) => Action<number>
  uploadPop: (payload: PopUploadParams) => Action<void>
}

export const actions: Actions = prepareActions(actionsNames, 'pop') as Actions

export default handleActions<State, any>(
  {
    [actions.setMaxDocuments.toString()]: (state: State, action: Action<number>): State =>
      state.set('maxDocuments', action.payload),
  },
  initialState
)
